// extracted by mini-css-extract-plugin
module.exports = {"speciality":"Author_speciality__1g71F"};